export default { sha: '996bedae42b24d7de3919f4d8805286f01a1403a', buildNumber: 'undefined' }
